import React from 'react'
import { Link } from 'gatsby';

const Image = (props) => (
     <Link>
     <img src={props.imageName} alt="" />
     </Link>
      );
export default Image;